export const LocalStorageProviderFactory = ({
  localStorage,
}: IlocalStorageProviderFactory) => ({
  get: (key: string) => localStorage.getItem(key),
  set: (key: string, value: string) => localStorage.setItem(key, value),
  remove: (key: string) => localStorage.removeItem(key),
  clear: () => localStorage.clear(),
});

export type IlocalStorageProvider = ReturnType<
  typeof LocalStorageProviderFactory
>;
